import React from "react";
import OfrendaIMG from "./img/ofrenda1.jpg";
import { Typography } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ChurchIcon from "@mui/icons-material/Church";
import "./ofrenda.css";

function Ofrenda() {
  return (
    <>
      <div className="img-container">
        <img src={OfrendaIMG} alt="iglesia-la-fe" />
        <Typography variant="h1" component="h1">
          Ofrendas y Diezmos
        </Typography>
      </div>

      <section className="page-section">
        <div className="container">
          <div className="ofrenda-info">
            <div className="ofrenda-info-header">
              <Typography variant="h3">Maneras de dar</Typography>
              <Typography variant="body1">
                Tu generosidad nos ayuda a continuar la obra de Dios en nuestra
                comunidad
              </Typography>
            </div>

            <div className="ofrenda-cards">
              <div className="ofrenda-card">
                <div className="ofrenda-icon">
                  <AccountBalanceIcon />
                </div>
                <Typography variant="h4">Cuenta Banco General</Typography>
                <Typography variant="body1">
                  Realiza tu ofrenda de forma segura a través de transferencias
                  bancarias directas a nuestra cuenta oficial.
                </Typography>
                <div className="ofrenda-info-box">
                  <Typography variant="h6">Información Bancaria</Typography>
                  <div>
                    <Typography variant="body2">
                      <strong>Banco:</strong> Banco General
                    </Typography>
                    <Typography variant="body2">
                      <strong>Cuenta:</strong> 123-456789-0
                    </Typography>
                    <Typography variant="body2">
                      <strong>Titular:</strong> Iglesia Evangélica de la Fe
                    </Typography>
                    <Typography variant="body2">
                      <strong>Tipo:</strong> Cuenta Corriente
                    </Typography>
                  </div>
                </div>
              </div>

              <div className="ofrenda-card">
                <div className="ofrenda-icon">
                  <ChurchIcon />
                </div>
                <Typography variant="h4">En Nuestros Cultos</Typography>
                <Typography variant="body1">
                  Durante nuestros servicios, puedes depositar tu ofrenda en las
                  cajas de ofrenda ubicadas en el templo.
                </Typography>
                <div className="ofrenda-info-box">
                  <Typography variant="h6">Horarios de Servicios</Typography>
                  <div>
                    <Typography variant="body2">
                      <strong>Domingo:</strong> 9:00 AM - 11:00 AM
                    </Typography>
                    <Typography variant="body2">
                      <strong>Miércoles:</strong> 7:00 PM - 8:30 PM
                    </Typography>
                    <Typography variant="body2">
                      <strong>Viernes:</strong> 7:00 PM - 8:30 PM
                    </Typography>
                    <Typography variant="body2">
                      <strong>Ubicación:</strong> Cajas de ofrenda en el templo
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Ofrenda;
